<template>
  <form-organization-branch-editing
    v-bind="$props"
    v-on:submit="onSubmit"
  >
    <template slot="branch-name">
      <input-text
        class="organization-branch-form__field"
        placeholder="Новый"
        title="Название филиала"
        v-bind:required="false"
        v-model="branchName"
        v-bind:violations="branchNameInputErrors" />
    </template>
  </form-organization-branch-editing>
</template>

<script>
import FormOrganizationBranchEditing from '@/components/FormOrganizationBranchEditing.vue';
import InputText from '@/components/InputText.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  (vm.$props.disabled !== true && cause in vm.$props.violationCauses)
    ? vm.$props.violationCauses[cause]
    : []
);

/**
 * @description Форма добавления филиала.
 * @type {Vue}
 */
export default {
  components: {
    FormOrganizationBranchEditing,
    InputText,
  },
  computed: {
    branchNameInputErrors: resolveInputErrors('branch_name'),
  },
  data() {
    return {
      /**
       * @description Название филиала.
       * @type {string}
       */
      branchName: '',
    };
  },
  extends: FormOrganizationBranchEditing,
  methods: {
    /**
     * @description Обработать отправку данных.
     * @param {object} data Данные.
     * @returns {void}
     */
    onSubmit(data) {
      this.$emit('submit', { branchName: this.branchName, clinicName: this.branchName, ...data });
    },
  },
  name: 'FormOrganizationBranchAdding',
};
</script>
